// v1.0.3 – Prosty overlay ładowania, nie usuwamy żadnej funkcji

import React from "react";

export default function EditorOverlay({
  showOverlay,
  fontsAreLoaded,
  assetsAreLoaded,
  assetsCount,
  assetsTotal,
  // Nowe propsy dla auto-centrowania
  isAutoCentering,
  autoCenteringProgress
}) {
  // Zmieniamy warunek - pokazuj overlay jeśli trwa ładowanie LUB auto-centrowanie
  if (!showOverlay && !isAutoCentering) return null;

  // Ewentualnie liczymy procenty
  let progressText = "";
  if (!fontsAreLoaded) {
    progressText = "Ładowanie czcionek...";
  } else if (!assetsAreLoaded && assetsTotal > 0) {
    const percent = Math.round((assetsCount / assetsTotal) * 100);
    progressText = `Ładowanie grafik: ${assetsCount}/${assetsTotal} (${percent}%)`;
  } else {
    progressText = "Inicjalizacja edytora...";
  }

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 9999,
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255,255,255,0.85)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <style>{`
        @keyframes spin2 {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div
        style={{
          width: "60px",
          height: "60px",
          border: "8px solid #ccc",
          borderTop: "8px solid #666",
          borderRadius: "50%",
          animation: "spin2 1s linear infinite"
        }}
      />
      {/* Pokazuj tekst ładowania tylko jeśli NIE trwa auto-centrowanie */}
      {!isAutoCentering && <div style={{ marginTop: "15px", fontSize: "18px", color: "#333" }}>{progressText}</div>}

      {/* Dodajemy wskaźnik dla auto-centrowania */}
      {isAutoCentering && (
        <div style={{ marginTop: 15, fontSize: 16, color: "#555", textAlign: 'center' }}>
          Automatyczne centrowanie... {autoCenteringProgress}%
          <div style={{ width: '150px', backgroundColor: '#e0e0e0', borderRadius: 4, overflow: 'hidden', height: 10, marginTop: 8, margin: '8px auto 0' }}>
            <div style={{ width: `${autoCenteringProgress}%`, backgroundColor: '#76c7c0', height: '100%' }}></div>
          </div>
        </div>
      )}
    </div>
  );
}
